/* eslint-disable array-callback-return */
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ERLAUTERUNG_IN_KOSTEN_TITLE,
	KOSTEN_ARTEN,
	KOSTEN_POSITION,
	PARTNER_DATEN_NICHT_ERFASST,
} from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
import { getFormStrucComponentTable } from 'src/utils/formStruc';
import { addIndexesToPath, checkReadOnlyInUeberarbeitung, getOptionsFromRes, removeDataKeys, removeNullDeep } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
} from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import kostenKategorieSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenKategorieSchema.attributes;

const SachkostenAntragLogMob: FC<{ kostentraeger: string; unternehmenId?: number; hasComment?: boolean }> = ({
	kostentraeger,
	unternehmenId,
	hasComment,
}) => {
	const { application, setApplicationProperty, readOnly, saveApplication } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddSachkosten = async () => {
		let appCopy = cloneDeep(application);

		const data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for Sachkosten, to find default Kostenkategorie id
			kostentraeger,
			unternehmenId,
			KOSTEN_POSITION.Ausgabe,
			KOSTEN_ARTEN.Sachkosten,
		);
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(application, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};

	const handleDeleteSachKosten = async (id: number) => {
		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};

	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: KOSTEN_POSITION.Ausgabe,
						Allgemein_Kostenart_Finanzierung: KOSTEN_ARTEN.Sachkosten,
						Allgemein_Antragsformular: {
							$contains: get(application, P.Allgemein_Antragsformular.path),
						},
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data', []))));
			} catch (err: any) {
				console.error('ERROR: FEtching Kosten kategorie ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
				if (
					get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
					get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Sachkosten &&
					get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`Sachkosten ${get(ele, KP_P.Allgemein_Bezeichnung.path, '')}`}
							onDelete={() => handleDeleteSachKosten(get(ele, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, ele)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapSachKosten(PruefAssistenzStruc(), i)}
							/>

							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(kostenKategorie, get(ele, KP_P.Allgemein_Kostenkategorie.path))}
							/>

							<Grid2 spacing={6} container>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapSachKosten(formStruc1(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapSachKosten(kostenProJahrStruc(application, i), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
									/>
								</Grid2>
							</Grid2>
						</MUIAccordionComponent>
					);
				}
			})}
			{unternehmenId ?
				<Button sx={{ mt: '2rem' }} endIcon={<AddIcon />} disabled={updatedReadOnly} onClick={handleAddSachkosten}>
					Sachkosten hinzufügen
				</Button>
			:	<MUIAlert message={PARTNER_DATEN_NICHT_ERFASST} />}
		</>
	);
};

export default SachkostenAntragLogMob;

const PruefAssistenzStruc = () => {
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
};
const formStruc1 = (kostenKategorie?: any[]) => {
	const kategorieOptions = kostenKategorie || [];
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'singleSelect',
					options: getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung'),
				},
				P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};
const formStruc2 = () => [
	{
		fields: [
			P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung,
			{
				...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme,
				format: 'currency',
				disabled: true,
			},
		],
		userProps: { direction: 'column', columnToDivide: 1 },
	},
];
const kostenProJahrStruc = (application: any, i: number) => [
	{
		fields: [
			{
				...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr,
				fieldProps: { Zelle_2: { format: 'currency' } },
				disabledColumns: ['Zelle_1'],
				type: 'componentTable',
				tableLabel: 'Ausgaben pro Jahr',
				maxLevel: get(application, P.Allgemein_Projektdauerin_Jahren.path),
				hideDeleteButton: true,
				sumRow: [
					{
						id: 'pinnedRow',
						Zelle_1: 'Gesamt',
						Zelle_2: get(
							application,
							addIndexesToPath(
								P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
								[`${i}`],
								['Foerderantrag_Kostenpositions'],
							),
						),
					},
				],
			},
		],
		userProps: { columnToDivide: 1 },
	},
];

const mapSachKosten = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				return {
					...value,
					path: addIndexesToPath(get(value, 'path', ''), [`${index}`], ['Foerderantrag_Kostenpositions']),
				};
			}),
		};
	});
	return result;
};

export function getFormStrucSachkostenAntragLogMob(application: any, unternehmenId?: number): FormStrucItem[] {
	let formStruc: FormStrucItem[] = [];

	get(application, P.Foerderantrag_Kostenpositions.path, []).forEach((ele: any, i: number) => {
		if (
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Sachkosten &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const isHinweisFieldRequired = checkIfPruefAssitenzNeedsToValidate(ele, KP_P.Pruefung_Pruefstatus.path, KP_P.Pruefung_Erledigt.path);

			const formStrucCTWithIndex = getFormStrucComponentTable(application, mapSachKosten(kostenProJahrStruc(application, i), i));

			const formStruc1WithIndex = mapSachKosten(formStruc1(), i);
			const formStruc2WithIndex = mapSachKosten(formStruc2(), i);

			if (isHinweisFieldRequired) {
				formStruc = concat(mapSachKosten(PruefAssistenzStruc(), i), formStruc, formStruc1WithIndex, formStruc2WithIndex);
			} else {
				formStruc = concat(formStruc, formStruc1WithIndex, formStruc2WithIndex, formStrucCTWithIndex);
			}
		}
	});
	return formStruc;
}
